import { Navigate, Outlet } from 'react-router-dom';
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProtectedRoute = (el) => {
    console.log(el);
    const [user, setUser] = useLocalStorage("user", null);
    console.log(user);

    useEffect(() => {
        
        if (!user) {
            toast.warning("Vous devez vous connecter pour accéder à cette page");
        }
    }, [user]);

    if (!user) {
        return <Navigate to="/" />;
    }
    return <Outlet  />;
};

export default ProtectedRoute;